module.exports = __webpack_public_path__ + "42f6b19d89d011bc16444e5a55f93b7b.pdf";